import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';

@customElement('visual-lightprofile')
export class VisualLightprofile extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		width: 100%;
	  }
	  .lightProfileContainer {
		display: grid;
		grid-template-columns: 9fr 3fr;
		gap: 50px;
		width: 100%;
		margin-right: var(--large-padding);
	  }
	  .graphics {
		display: flex;
		gap: 10px;
		flex-direction: column;
	  }
	  .parameters {
		display: block;
   	 	position: relative;
	  }

	  @media (max-width: 768px) {
		.lightProfileContainer {
			display: block;
			width: 100vw;
			margin: auto;
			margin-top: 35px;
			overflow-y: scroll;
			height: 100%;
		  }

		  .lightProfileContainer.summary {
			display: block;
			width: 90vw;
			margin: 35px auto auto -2vw;
			overflow: hidden;
			height: 100%;
			max-height: 90vh;
		  }

		  :host {
			display: -webkit-inline-box;
			width: 100%;
			min-height: 100vh;
			overflow-y: scroll;
			height: 100%;
		  }

		  .parameters {
			display: block;
		    margin: 0px auto;
   			width: 100%;
		  }

		  .graphics {
			display: block;
			max-height: 100%;
		  }
	  }

	`;
	static properties = {
		determineLocation: { type: String },
	  };

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
		this.determineLocation = this.getAttribute('determine-location') || '';
	}
	stateChanged(state) {
		this.state = state;
		this.simulationResult = state.lightProfile.data.simulationResult;
		this.translations = state.productData.translations;
	}
	render() {
		if (this.simulationResult === null) return null;
		// if (selectProfileId(s) === null || !selectLocationIsSatisfied(s)) return null;

		return html`
			<div class="lightProfileContainer ${this.determineLocation}">
				<div class="graphics">
					<light-profile-year></light-profile-year>
					<light-profile-day></light-profile-day>
				</div>
				<div class="parameters">
					<light-profile-parameters></light-profile-parameters>

				</div>
			</div>
			`;

	}
}
